import { useCallback, useRef, useState } from 'react'
import { useLoad } from '../hooks/load'
import { listConnectionLinks, listOwnLinks } from './scim-api'

// A page's SCIM link rows: undefined while they load, null if the read
// failed (failure is the error behind it, for its reference), else the
// rows. providerID: one connection's links (staff); none: the caller's
// organization's own links. enabled false reads nothing.
export const useScimLinks = ({ providerID, enabled = true } = {}) => {
  const [links, setLinks] = useState(undefined)
  const [failure, setFailure] = useState(null)
  const latest = useRef(0)

  const reload = useCallback(async () => {
    if (!enabled) return
    const call = ++latest.current
    try {
      const rows = providerID ? await listConnectionLinks(providerID) : await listOwnLinks()
      if (call !== latest.current) return
      setLinks(Array.isArray(rows) ? rows : [])
      setFailure(null)
    } catch (err) {
      if (call !== latest.current) return
      setLinks(null)
      setFailure(err)
    }
  }, [providerID, enabled])

  useLoad(() => reload(), [reload])

  return { links, failure, reload }
}
